// import React, { useEffect, useState } from 'react'
// import "./studioOffers.css"
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import { useNavigate } from 'react-router-dom';
// // import GetStartedModal from '../../../PopUp/GetStartedModal/GetStartedModal';
// import axios from 'axios';
// // import Loader from '../../Loader/Loader';
// import EnquiryForm from '../EnquiryForm/EnquiryForm';

// const StudioOffers = ({title='Celebrating 26th Anniversary!'}) => {

//     const [showModal,setShowModal] = useState(false)
//     const [anniversaryOffers,setAnniversaryOffers] = useState(null)
//     const offers = [
//         {
//             title:"3 Months",
//             banner:"/assets/3months.png",
//             descrip:"Get extra 3 months free with this plan!",
//             service:[
//                 {
//                     title:"Studio",
//                     price:"1499",
//                     freeFor:"Get 3 months free",
//                     permonth: 249
//                 },
//                 {
//                     title:"Online",
//                     price:"899",
//                     freeFor:"Get 3 months free",
//                     permonth: 149
//                 }
//             ],
//             validTill:"15 September, 2025"
//         },
//         {
//             title:"6 Months",
//             banner:"/assets/6months.png",
//             descrip:"Get extra 6 months free with this plan!",
//             service:[
//                 {
//                     title:"Studio",
//                     price:"2199",
//                     freeFor:"Get 6 months free",
//                     permonth: 183
//                 },
//                 {
//                     title:"Online",
//                     price:"1299",
//                     freeFor:"Get 6 months free",
//                     permonth: 109
//                 }
//             ],
//             validTill:"15 September, 2025"
//         },
//         {
//             title:"1 Year",
//             banner:"/assets/1year.png",
//             descrip:"Get extra 1 year free with this plan!",
//             service:[
//                 {
//                     title:"Studio",
//                     price:"3599",
//                     freeFor:"Get 1 year free",
//                     permonth: 149
//                 },
//                 {
//                     title:"Online",
//                     price:"2199",
//                     freeFor:"Get 1 year free",
//                     permonth: 91
//                 }
//             ],
//             validTill:"15 September, 2025"
//         }
//     ]

//     const [selectedOffer,setSelectedOffer] = useState('')
//     const handleOpenGetStartedModal = (offer) => {
//         setShowModal(true)
//         setSelectedOffer(offer)
//     }

//     useEffect(() => {
//       axios.get(`https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/api/anniversary-offers`).
//         then((res)=> {
//             setAnniversaryOffers(res.data)
//         })
//         .catch((err) => {
//             console.log(err)
//         })
//     }, [])

//     if(!anniversaryOffers){
//         return "Loading..."
//     }
    

//   return (
//     <>
//     <div className='studio-offers-container'>
//         <div className="studio-offers-header">
//             <h1>{title}</h1>
//             {/* <p>Register now, start later! Valid till <span>{anniversaryOffers?.validDate}</span></p> */}
//         </div>
        

//         <div className='studio-offer-list-container'>
//             {
//                 anniversaryOffers && anniversaryOffers.data.map((item,id) => (
//                     <div className='studio-offer-card' key={id}>
//                         <div className='studio-offer-banner'>
//                             <img src={item.banner} alt="" />
//                         </div>
//                         <div className='d-flex justify-content-center'>
//                             <img src="/assets/studio-offer-icon.png" alt="" />
//                         </div>
//                         <h1>{item.title}</h1>
//                         <h4>{item.descrip}</h4>

//                         <div className='d-flex flex-column gap-3 mt-3'>
//                             {
//                                 item.service.map((el) => (
//                                     <div className='service-offer-container'>
//                                         <div className="service-offer-header">
//                                             <h2>{el.title}</h2>
//                                             <div className='d-flex flex-column align-items-end'>
//                                                 <h3>AED <span>{el.price}</span></h3>
//                                                 {/* <p>~AED {el.permonth}/month</p> */}
//                                             </div>
//                                         </div>
//                                         <div className="service-offer-body">
//                                             <p className='mb-0'>{el.freeFor}</p>
//                                             <a className='phone-no' target='_blank' href={`https://wa.me/971568819394?text= Hi`}>
//                                             <div className='join-us'>
//                                                 Join us
//                                                 <WhatsAppIcon/>
//                                             </div>
//                                             </a>
//                                         </div>
//                                     </div>
//                                 ))
                                
//                             }
//                         </div>
                        
//                         {/* <hr /> */}

//                         {/* <h5>Valid till <span>{item.validTill}</span></h5> */}
                        
//                         <button onClick={()=>setShowModal(true)}>Get Started</button>
//                     </div>
//                 ))
//             }
//         </div>
//     </div>
//     {
//         showModal && <EnquiryForm title={'Book Your Free Trial Today!'} setEnquiryPopUp={setShowModal}/>
//     }
//     </>
//   )
// }

// export default StudioOffers

// const WhatsAppIcon = () => {
//     return(
//         <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
//             <path d="M0.797533 7.78078C0.797205 8.96612 1.10692 10.1235 1.69585 11.1437L0.741211 14.6292L4.30822 13.6939C5.29481 14.231 6.40021 14.5124 7.52352 14.5125H7.52647C11.2347 14.5125 14.2533 11.495 14.2549 7.78608C14.2556 5.98885 13.5564 4.29886 12.2859 3.02739C11.0156 1.75604 9.32622 1.05551 7.5262 1.05469C3.81751 1.05469 0.799119 4.07204 0.797588 7.78078" fill="url(#paint0_linear_1416_6137)"/>
//             <path d="M0.55851 7.77863C0.558127 9.00662 0.878946 10.2054 1.48887 11.2621L0.5 14.8726L4.19491 13.9038C5.21298 14.4588 6.35922 14.7515 7.52559 14.7519H7.52859C11.3699 14.7519 14.4969 11.6259 14.4986 7.78421C14.4992 5.9224 13.7748 4.17165 12.4589 2.85463C11.1429 1.53778 9.39308 0.812045 7.52859 0.811279C3.68664 0.811279 0.560041 3.9369 0.55851 7.77863ZM2.75896 11.0801L2.621 10.8611C2.04105 9.93895 1.73494 8.87331 1.73537 7.77907C1.73658 4.58592 4.33528 1.98803 7.53078 1.98803C9.07828 1.98869 10.5326 2.59194 11.6265 3.68645C12.7203 4.78108 13.3221 6.23616 13.3218 7.78377C13.3203 10.9769 10.7216 13.5751 7.52859 13.5751H7.5263C6.48663 13.5746 5.46698 13.2954 4.57774 12.7678L4.36612 12.6423L2.17349 13.2171L2.75896 11.0801Z" fill="url(#paint1_linear_1416_6137)"/>
//             <path d="M5.78493 4.86588C5.65446 4.5759 5.51716 4.57005 5.39308 4.56496C5.29148 4.56059 5.17534 4.56092 5.0593 4.56092C4.94316 4.56092 4.75445 4.60461 4.59495 4.77877C4.43527 4.9531 3.98535 5.37437 3.98535 6.23118C3.98535 7.08804 4.60944 7.91609 4.69644 8.0324C4.78354 8.14849 5.90124 9.96305 7.6714 10.6611C9.14257 11.2412 9.44195 11.1259 9.76124 11.0968C10.0806 11.0678 10.7917 10.6756 10.9367 10.2689C11.0819 9.86233 11.0819 9.51379 11.0384 9.44095C10.9949 9.36839 10.8787 9.32481 10.7046 9.23775C10.5303 9.15065 9.67413 8.72932 9.51451 8.67119C9.35484 8.61312 9.23875 8.58414 9.12261 8.75852C9.00646 8.93263 8.67296 9.32481 8.5713 9.44095C8.46976 9.55737 8.36811 9.57186 8.194 9.48475C8.01973 9.39737 7.45886 9.21369 6.79343 8.62045C6.2757 8.15882 5.92618 7.58877 5.82458 7.41439C5.72298 7.24028 5.8137 7.1459 5.90102 7.05912C5.97927 6.98109 6.07524 6.85575 6.1624 6.7541C6.24924 6.65239 6.27822 6.57983 6.33629 6.46369C6.39442 6.34743 6.36533 6.24572 6.32185 6.15862C6.27822 6.07151 5.93979 5.21021 5.78493 4.86588Z" fill="white"/>
//             <defs>
//                 <linearGradient id="paint0_linear_1416_6137" x1="676.426" y1="1358.51" x2="676.426" y2="1.05469" gradientUnits="userSpaceOnUse">
//                 <stop stop-color="#1FAF38"/>
//                 <stop offset="1" stop-color="#60D669"/>
//                 </linearGradient>
//                 <linearGradient id="paint1_linear_1416_6137" x1="700.428" y1="1406.94" x2="700.428" y2="0.811279" gradientUnits="userSpaceOnUse">
//                 <stop stop-color="#F9F9F9"/>
//                 <stop offset="1" stop-color="white"/>
//                 </linearGradient>
//             </defs>
//             </svg>
//     )
// }

import { useState } from 'react'
import "./studioOffers.css"

const TABS = ['Studio Classes']

const PLANS = {
  'Online Classes': [
    {
      title: '1 Month',
      originalPrice: '399',
      originalStrikethrough: true,
      discountedPrice: 'AED 199',
    },
    {
      title: '3 Months',
      originalPrice: '999',
      originalStrikethrough: true,
      discountedPrice: 'AED 499',
    },
    {
      title: '6 Months',
      originalPrice: '1599',
      originalStrikethrough: false,
      discountedPrice: 'AED 799',
    },
    {
      title: '12 Months',
      originalPrice: '2499',
      originalStrikethrough: false,
      discountedPrice: 'AED 1299',
    },
  ],
  'Studio Classes': [
    {
      title: '1 Month',
      originalPrice: '799',
      originalStrikethrough: true,
      discountedPrice: 'AED 499',
    },
    {
      title: '3 Months',
      originalPrice: '1599',
      originalStrikethrough: true,
      discountedPrice: 'AED 1199',
    },
    {
      title: '6 Months',
      originalPrice: '2099',
      originalStrikethrough: true,
      discountedPrice: 'AED 1499',
    },
    {
      title: '12 Months',
      originalPrice: '3899',
      originalStrikethrough: true,
      discountedPrice: 'AED 2399',
    },
  ],
  'App Classes': [
    {
      title: '1 Month',
      originalPrice: '399',
      originalStrikethrough: true,
      discountedPrice: 'AED 199',
    },
    {
      title: '2 Months\n+\n1 Month Free',
      originalPrice: '699',
      originalStrikethrough: true,
      discountedPrice: 'AED 499',
    },
    {
      title: '3 months\n+\n3 months free',
      originalPrice: '999',
      originalStrikethrough: false,
      discountedPrice: 'AED 799',
    },
  ],
}

function PricingCard({ title, originalPrice, originalStrikethrough, discountedPrice }) {
  const titleLines = title.split('\n')

  return (
    <div className="pricing-card">
      <div className="pricing-card__title">
        {titleLines.map((line, i) => (
          <span key={i}>
            {line}
            {i < titleLines.length - 1 && <br />}
          </span>
        ))}
      </div>
      <div className="pricing-card__price-block">
        <p className="pricing-card__original-price">
          (AED{' '}
          {originalStrikethrough ? (
            <span className="pricing-card__strikethrough">{originalPrice}</span>
          ) : (
            originalPrice
          )}
          )
        </p>
        <p className="pricing-card__discounted-price">{discountedPrice}</p>
      </div>
      <a
        href="https://wa.me/971585759017"
        target="_blank"
        rel="noopener noreferrer"
        className="pricing-card__cta"
      >
        Register Now
      </a>
    </div>
  )
}

export default function StudioOffers() {
  const [activeTab, setActiveTab] = useState('Studio Classes')

  return (
    <section className="pricing">
      <div className="pricing__header">
        <h2 className="pricing__heading">Pricing (Regular Classes)</h2>
        <p className="pricing__validity">
          Register now! Valid till{' '}
          <span className="pricing__validity-date">10th July 2026</span>
        </p>
      </div>

      <div className="pricing__content">
        {/* <div className="pricing__tabs">
          {TABS.map((tab) => (
            <button
              key={tab}
              className={`pricing__tab${activeTab === tab ? ' pricing__tab--active' : ''}`}
              onClick={() => setActiveTab(tab)}
              disabled={tab === 'App Classes'}
            >
              {tab}
            </button>
          ))}
        </div> */}

        <div className="pricing__cards">
          {PLANS[activeTab].map((plan) => (
            <PricingCard key={plan.title} {...plan} />
          ))}
        </div>

        <p className="pricing__disclaimer">
          Disclaimer: <span className="pricing__disclaimer-asterisk">*</span>Prices are inclusive of 5% VAT
        </p>
      </div>
    </section>
  )
}
